import CoachProfileOfferingsShop from './coach-profile-offerings-shop'

export default CoachProfileOfferingsShop
